import GriyasaLogo from '../assets/img/logo/griyasa-logo.svg';
import MapsIcon from '../assets/img/icon/maps-icon.svg';
import MailIcon from '../assets/img/icon/mail-icon.svg';
import PhoneIcon from '../assets/img/icon/phone-icon.svg';
import InstagramIcon from '../assets/img/social-media/instagram.svg';
import LinkedinIcon from '../assets/img/social-media/linkedin.svg';
import FacebookIcon from '../assets/img/social-media/facebook.svg';
import TwitterIcon from '../assets/img/social-media/twitter.svg';

import { useEffect } from 'react';
import { useTranslation } from "react-i18next";

function Footer() {
    const { t } = useTranslation();

    useEffect(() => {
        const divId = document.getElementById('current-year');
        var currentYear = new Date();
        divId.innerHTML = currentYear.getFullYear();
    }, []);

    return (
        <footer>
            <div className='container-footer'>
                <div className='footer-group logo'>
                    <img src={GriyasaLogo} alt='Griyasa Logo' />
                    <p className='logo-theme'>Democratizing Homes</p>
                </div>

                <div className='footer-group'>
                    <h2>{t('contact-us')}</h2>
                    <div className='grouping'>
                        <img src={MapsIcon} alt='Maps Icon' />
                        <a href='https://www.google.com/maps/place/Wellspaces+Treasury+Tower+SCBD+Coworking+Space+%26+Serviced+Office/@-6.2280311,106.803791,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f15c82c4d35f:0x8db622e27d70a919!8m2!3d-6.2280364!4d106.8063659!16s%2Fg%2F11c31x3slq?entry=ttu&g_ep=EgoyMDI0MDkwOC4wIKXMDSoASAFQAw%3D%3D'
                            target='_blank' rel='noreferrer'>
                            <p>Treasury 9th Floor SCBD Lot 28</p>
                        </a>
                    </div>
                    <div className='grouping'>
                        <img src={MailIcon} alt='Mail Icon' />
                        <a href='mailto:customer.care@griyasa.com'><p>customer.care@griyasa.com</p></a>
                    </div>
                    <div className='grouping'>
                        <img src={PhoneIcon} alt='Phone Icon' />
                        <a href='tel:02150103363'><p>021 - 5010 3363</p></a>
                    </div>
                </div>
                <div className='footer-group'>
                    <h2>{t('footer-quick-links')}</h2>
                    <a href='/about-us'><p>{t('about-us')}</p></a>
                    <a href='/our-team'><p>{t('our-team')}</p></a>
                    <a href='/gallery'><p>{t('gallery')}</p></a>
                    <a href='/contact-us'><p>{t('contact-us')}</p></a>
                </div>
                <div className='footer-grouping-sosmed'>
                    <a href='https://www.instagram.com/' rel='noreferrer' target='_blank'><img src={InstagramIcon} alt='Instagram Icon' /></a>
                    <a href='https://www.linkedin.com/' rel='noreferrer' target='_blank'><img src={LinkedinIcon} alt='Linked In Icon' /></a>
                    <a href='https://www.facebook.com/' rel='noreferrer' target='_blank'><img src={FacebookIcon} alt='Facebook Icon' /></a>
                    <a href='https://x.com/' rel='noreferrer' target='_blank'><img src={TwitterIcon} alt='Twitter Icon' /></a>
                </div>
            </div>
            <div className='footer-group est'>
                <p>© <span id='current-year'>current year by javascript</span> PT Arga Arta Abadi Selaras</p>
            </div>
        </footer>
    );
}

export default Footer;